module.exports = __webpack_public_path__ + "static/img/wgq.4bf17d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/wgq.jpg
// module id = 1413
// module chunks = 0